import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDependenciasEmpleador } from "../../../../redux/actions/empleador";
import { clearPostRgrl, clearRgrl, clearSearchedRgrl, getDatosEstablecimiento, getFormulariosPresentados, getValidarDisponibilidadCargaRgrl, postSearchedRgrl, requerirActividadDecretos, } from "../../../../redux/actions/rgrl";
import ConfirmDialog from "../../../commons/dialog/ConfirmDialog";
import SearchEstablecimiento from "../../../commons/establecimiento/SearchEstablecimiento";
import EstablecimientoForm from "./establecimientoForm/EstablecimientoForm";

const EstablecimientoContainer = ({ nextForm, fromBread }) => {
  const dispatch = useDispatch();

  const searchedRgrl = useSelector((state) => state.rgrl.searchedRgrl);
  const dependenciasEmpleador = useSelector(
    (state) => state.empleador.dependenciasEmpleador
  );

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [searchModel, setSearchModel] = useState(null);
  const [selectedValue, setSelectedValue] = useState(searchedRgrl ?? null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setSearchModel({ establecimiento: selectedValue, soloActivos: checked });
  }, [selectedValue, checked]);

  useEffect(() => {
    dispatch(getDependenciasEmpleador());
  }, []);

  useEffect(() => {
    if (!fromBread) {
      dispatch(clearRgrl());
    }
  }, []);

  const getCards = (values) => {
    dispatch(getDatosEstablecimiento(values.establecimiento));
    dispatch(getFormulariosPresentados(values.establecimiento));
  };

  const handleSearch = (values) => {
    dispatch(clearPostRgrl());
    if (values?.establecimiento) {
      dispatch(postSearchedRgrl(values.establecimiento));
      getCards(values);
      dispatch(getValidarDisponibilidadCargaRgrl(values.establecimiento));
      dispatch(requerirActividadDecretos());
    } else {
      dispatch(clearSearchedRgrl());
    }
  };

  return (
    <>
      <SearchEstablecimiento
        options={dependenciasEmpleador.data}
        handleSearch={handleSearch}
        searchModel={searchModel}
        searched={searchedRgrl}
        setOpenConfirmDialog={() => setOpenConfirmDialog(true)}
        setSelectedValue={setSelectedValue}
        setChecked={setChecked}
      />
      <EstablecimientoForm searchedRgrl={searchedRgrl} nextForm={nextForm} />
      <ConfirmDialog
        open={openConfirmDialog}
        handleClose={() => {
          setOpenConfirmDialog(false);
          setSelectedValue(searchedRgrl);
          setSearchModel({ establecimiento: searchedRgrl });
        }}
        handleConfirm={() => {
          handleSearch({ establecimiento: selectedValue });
          setOpenConfirmDialog(false);
        }}
        title="Perderá todos los datos completados"
        text={
          "Al buscar otro establecimiento los datos cargados anteriormente se perderán."
        }
        loading={false}
      />
    </>
  );
};

export default EstablecimientoContainer;
